import React from 'react';
/**
 * Audio-waveform glyph for the echo-cancellation toolbar button, matching the
 * demo's エコーキャンセル icon. Drawn with filled rounded bars so it inherits the
 * icon color via `fill: currentColor` (theme-aware) instead of a fixed color.
 *
 * @param {any} props - Icon props injected by the Jitsi `Icon` wrapper
 * (width/height/fill/aria-*).
 * @returns {JSX.Element}
 */
export default function IconNkfAecWave(props) {
    return (React.createElement("svg", { height: 24, viewBox: '0 0 24 24', width: 24, xmlns: 'http://www.w3.org/2000/svg', ...props },
        React.createElement("rect", { fill: 'currentColor', height: 4, rx: 1, width: 2, x: 3, y: 10 }),
        React.createElement("rect", { fill: 'currentColor', height: 10, rx: 1, width: 2, x: 7, y: 7 }),
        React.createElement("rect", { fill: 'currentColor', height: 16, rx: 1, width: 2, x: 11, y: 4 }),
        React.createElement("rect", { fill: 'currentColor', height: 8, rx: 1, width: 2, x: 15, y: 8 }),
        React.createElement("rect", { fill: 'currentColor', height: 2, rx: 1, width: 2, x: 19, y: 11 })));
}
